import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../../../api.service';

@Component({
  selector: 'app-reportingtolist',
  templateUrl: './reportingtolist.component.html',
  styleUrls: ['./reportingtolist.component.css']
})
export class ReportingtolistComponent implements OnInit {
  rows = [];
  searchQR: any;
  value1: any;
  final_data : any;
  original_portfolio_list: any;
  origianl_bank_list : any;

  portfolio_list: any;
  booleans: boolean;
  constructor(
    private router: Router,
    private _api: ApiService,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    private http: HttpClient,
  ) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.saveInLocal('Entity_data', undefined);
  //  this.bank_list_get();
  //   this.portfolio_list_get();
  // this.getFromLocal("User_ID")
    let a  = {
      member_user_id : "60699c02911c8735d0c34201" 
    }
    this._api.fetch_reporting_to_by_id(a).subscribe(
      (response: any) => {
        console.log(response);
        let rows = response.Data.reverse();
        this.rows = rows;
        console.log(this.rows);
      }
    );

  }
  saveInLocal(key, val): void {
    this.storage.set(key, val);
  }

  getFromLocal(key): any {
    return this.storage.get(key);
  }

  allocation_data(data){
    console.log(data);
    this.saveInLocal('Report_to_id', data);
    this.router.navigateByUrl('/userflow/reportingtoallocate');
  

    
  }
  
}
